import { useRoute } from 'shared/src/hooks/useRoute';

export type MyPageParamList = {
  AddressList: {
    instanceId?: string;
    mode?: 'manage' | 'select';
  };
  AlarmSetting: {
    instanceId?: string;
  };
  Laboratory: {
    instanceId?: string;
  };
  MyPersonalization: {
    instanceId?: string;
    from?: string;
    initialTabIndex?: number;
    productCategorySno?: number;
  };
  PointOfContact: {
    instanceId?: string;
  };
  Setting: {
    instanceId?: string;
  };
  MyInfo: {
    instanceId?: string;
    from?: string;
  };
};

export const useMyPageRoute = <Key extends keyof MyPageParamList>() =>
  useRoute<MyPageParamList, Key>();
